import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {ClientService} from "./Client.service";
import {CreateClientData, FeClient, UpdateClientInput, UpdateClientResult} from "./types";

const clientService = new ClientService();

export const createClientThunk = createErrorHandlingThunk<FeClient, CreateClientData>(
    'clients/create',
    (dto) => clientService.createClient(dto)
);

export const updateClientThunk = createErrorHandlingThunk<UpdateClientResult, { id: string, dto: UpdateClientInput }>(
    'clients/update',
    (args) => clientService.updateClient(args.id, args.dto)
);

export const listClientsThunk = createErrorHandlingThunk(
    'clients/list',
    () => clientService.listClients()
);

export const getClientThunk = createErrorHandlingThunk<FeClient, {id: string}>(
    'clients/get',
    (args) => clientService.getClient(args.id)
);